import React, { Component }      from 'react';
import { withRouter }            from 'react-router';
import { connect }               from 'react-redux';
import UrlShortenerBreadcrumb    from './Breadcrumb';
import { UrlShortenerConstants } from './environment';
import List                      from './Admin/List';
import Required                  from '../../Required';
import { isLoggedIn }            from '../../../utils/authService';
import { isInRoleFromToken }     from '../../../utils/authService';
import { redirect }              from '../../../utils/authService'; 

class UrlShortener extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Redirector';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(path.replace(/^\/|\/$/g, ''));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (isInRoleFromToken(UrlShortenerConstants.AdminRole)) {
      let component = null;
      if (path.startsWith(UrlShortenerConstants.AdminPathPrefix + '/list')) {
        component = <List />; 
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <UrlShortenerBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      // Not logged in or wrong role
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  pubsub: state.pubsub
});

export default withRouter(connect(mapStateToProps)(UrlShortener));
